module.exports = __webpack_public_path__ + "static/media/banner.4348b84f.svg";